module.exports = "https://web-assets-production.autolist.com/_next/static/images/be-in-the-know-540a25b5f336061e7c99d2fb54c58747.png";